import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { createSaveCustomerGroupContact, getCustomerGroupContact } from '../../../../actions/customerGroupContact'
// import { loginAs } from '../../../../actions/auth'

// import styles
import './view.scss'

// Components
import Phone from '../../../../shared/components/Phone'
// import HelpText from '../../../../shared/components/HelpText'

// Elements
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Text from '../../../../shared/elements/text'
import Switch from '../../../../shared/elements/switch'

// Utils
import { hasAccess } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      contact: {
        UserId: null,
        UserName: '',
        Name: '',
        Email: '',
        EmailIsValid: false,
        Phone: '',
        PhoneCode: this.props.phonecode,
        PhoneIsValid: false,
        CustomerGroupId: props.customerGroupId,
        ChainId: props.chainId,
        Active: false
      }
    }
    // console.log('constructor props', props)
    this.onInputChange = this.onInputChange.bind(this)
    this.saveAddContact = this.saveAddContact.bind(this)
    this.addContact = this.addContact.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getCustomerGroupContact(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.UserId !== nextProps.item.UserId) {
      this.getCustomerGroupContact(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }
    if (e.target.name === 'Active') {
      value = e.target.checked
    }
    this.setState({
      type: 'edit',
      contact: {
        ...this.state.contact,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'radio' || e.target.name === 'Active') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (this.state.contact.UserId !== undefined && this.state.contact.UserId !== null && this.state.contact.UserId !== 0) {
      this.setState({ type: 'edit' }, () => {
        this.saveAddContact()
      })
    }
  }

  getCustomerGroupContact (props) {
    if (props.item.UserId !== undefined && props.item.UserId !== null && props.item.UserId !== 0) {
      props.getCustomerGroupContact(props.item.UserId).then((res) => {
        let contact = res.data
        this.setState({
          type: 'edit',
          contact: contact
        })
      }, () => {
        this.props.onError()
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      contact: {
        UserId: null,
        Phone: '',
        PhoneCode: this.props.phonecode,
        PhoneIsValid: false,
        Active: false,
        UserName: '',
        Name: '',
        Email: '',
        CustomerGroupId: this.props.customerGroupId,
        ChainId: this.props.chainId,
        EmailIsValid: false
      }
    })
  }

  onInputChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (name === 'PhoneNumber') {
      name = 'Phone'
      this.setState({
        contact: {
          ...this.state.contact,
          [name]: value
        }
      })
    } else {
      this.setState({
        contact: {
          ...this.state.contact,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => { this.onBlur() })
    }
  }

  // sendNewPassword (e) {
  //   e.preventDefault()
  //   if (!this.state.contact.EmailIsValid) {
  //     window.toastr.error(translation('Email is required to send password @'), translation('216'))
  //   } else {
  //     let data = {
  //       UserId: this.state.contact.UserId
  //     }
  //     this.props.sendPassword(data).then((res) => {
  //       // window.toastr.success(translation('Contact password has been sent @'), translation('13424'))
  //     }, () => {
  //       window.toastr.error(translation('Failed to send contact password @'), translation('216'))
  //     })
  //   }
  // }

  /*  User name
            <div className='control__group'>
              <label>{translation('1')}</label>
              <input type='text' name='UserName' value={contact.UserName || ''} onChange={this.onChange} />
            </div>
  */

  /*  Send password
            <div>
              {this.state.contact.UserId !== 0 && typeof this.state.contact.UserId !== 'undefined' && (
                <div className='control__group'>
                  <label>{translation('2')} <HelpText text={translation('Help text @')} /></label>
                  <button className='button full primary half' style={{ marginTop: 0 }} onClick={this.sendNewPassword} disabled='true'>{translation('Send password @')}</button>
                </div>
              )}
            </div>
  */

  renderContact () {
    let { contact } = this.state
    if (contact === null) return null
    return (
      <Panel title={translation('346')}>
        <Text name='Name' value={contact.Name || ''} onChange={this.onChange} labelText={translation('30')} />
        <Text name='UserName' value={contact.UserName || ''} onChange={this.onChange} labelText={translation('1')} />
        <Text name='Email' value={contact.Email || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('1052')} />
        <LabelWrapper labelText={translation('345')}>
          <Phone
            onChange={this.onInputChange}
            onBlur={this.onBlur}
            code={contact.PhoneCode}
            number={contact.Phone} />
        </LabelWrapper>
        <Switch name='Active' onChange={this.onChange} checked={contact.Active} disabled labelText={translation('295')} />
      </Panel>
    )
  }

  addContact () {
    this.setState({ type: 'create' }, () => {
      this.props.createSaveCustomerGroupContact(this.state.contact).then((res) => {
        this.props.onSave(res.data, this.state.type)
      }, (err) => {
        // Toastr
        // console.log('err', err.response.data.Errors)
        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
          let errors = err.response.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        } else {
          window.toastr.error(translation('13463'), translation('216'))
        }
        // Toastr
        // window.toastr.error(translation('13463'), translation('216'))
      })
    })
  }

  saveAddContact () {
    this.props.createSaveCustomerGroupContact(this.state.contact).then((res) => {
      this.props.onSave(res.data, this.state.type)
      this.setState({
        contact: res.data
      })
    }, (err) => {
      // Toastr
      // console.log('err', err.response.data.Errors)
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('13463'), translation('216'))
      }
    })
  }

  render () {
    if (!hasAccess([2], this.props.auth.user.UserType)) return null
    return (
      <Col>
        {this.renderContact()}
      </Col>
    )
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode
  }
}

export default connect(mapStateToProps, {
  createSaveCustomerGroupContact,
  getCustomerGroupContact
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/CustomerGroups/Contacts/View/index.js